import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { SearchPanelContainer } from '@components/Search'
import FilterGroup from '@components/FilterGroup'
import { Autocomplete, Dropdown } from '@components/Autocomplete'
import { DatePickerRange } from '@components/DatePicker'
import Checkbox from '@components/Checkbox'

class InvoicesFilterPanel extends Component {
  static propTypes = {
    invoicesStore: PropTypes.object
  }

  searchOnEnter = e => {
    const { invoicesStore } = this.props
    if (e.keyCode === 13) {
      invoicesStore.query.page = 1
      invoicesStore.filter()
    }
  }

  searchOnClick = () => {
    const { invoicesStore } = this.props
    invoicesStore.query.page = 1
    invoicesStore.filter()
  }

  filterByParentAccount = parentAccount => {
    const { invoicesStore } = this.props
    if (parentAccount) {
      invoicesStore.parentAccountSuggestion = parentAccount.label
      invoicesStore.query.parentAccount = parentAccount.value
    } else {
      invoicesStore.parentAccountSuggestion = ''
      invoicesStore.query.parentAccount = ''
    }
    invoicesStore.query.page = 1
    invoicesStore.filter()
  }

  filterByAccount = account => {
    const { invoicesStore } = this.props
    if (account) {
      invoicesStore.accountSuggestion = account.label
      invoicesStore.query.account = account.value
    } else {
      invoicesStore.accountSuggestion = ''
      invoicesStore.query.account = ''
    }
    invoicesStore.query.page = 1
    invoicesStore.filter()
  }

  filterByInvoiceStatus = invoice => {
    const { invoicesStore } = this.props
    invoicesStore.currentInvoiceStatus = invoice
    invoicesStore.query.invoiceStatus = invoice.id
    invoicesStore.query.page = 1
    invoicesStore.filter()
  }

  filterByStartDate = date => {
    if (!date) return
    const { invoicesStore } = this.props
    invoicesStore.query.startDate = date
    invoicesStore.filter()
  }

  filterByEndDate = date => {
    if (!date) return
    const { invoicesStore } = this.props
    invoicesStore.query.endDate = date
    invoicesStore.filter()
  }

  filterUnpaidInvoices = checked => {
    const { invoicesStore } = this.props
    invoicesStore.query.unpaidOnly = checked
    invoicesStore.filter()
  }

  onClearSearch = () => {
    this.props.invoicesStore.clearSearch()
  }

  render () {
    const {
      query,
      invoiceStatuses,
      parentAccountSuggestion,
      accountSuggestion,
      currentInvoiceStatus,
      sentToClientOptions,
      setSentToClientFilter,
      sentStatus
    } = this.props.invoicesStore

    return (
      <SearchPanelContainer
        extrathin
        searchTitle='Search and Filter'
        onClearSearch={this.onClearSearch}
      >
        <FilterGroup label='Invoicing entity' onSearch={this.searchOnClick}>
          <input
            onKeyDown={this.searchOnEnter}
            onChange={e =>
              (this.props.invoicesStore.query.invoicingEntity = e.target.value)
            }
            value={query.invoicingEntity}
          />
        </FilterGroup>
        <FilterGroup label='Invoice No.' onSearch={this.searchOnClick}>
          <input
            onKeyDown={this.searchOnEnter}
            onChange={e =>
              (this.props.invoicesStore.query.invoiceNo = e.target.value)
            }
            value={query.invoiceNo}
          />
        </FilterGroup>
        <FilterGroup label='Parent account'>
          <Autocomplete
            value={parentAccountSuggestion}
            itemToString={item => item && item.label}
            onChange={this.filterByParentAccount}
            loadOptions={this.props.invoicesStore.autocompleteParentAccount}
          />
        </FilterGroup>
        <FilterGroup label='Account'>
          <Autocomplete
            value={accountSuggestion}
            itemToString={item => item && item.label}
            onChange={this.filterByAccount}
            loadOptions={this.props.invoicesStore.autocompleteAccount}
          />
        </FilterGroup>
        <FilterGroup label='Status'>
          <Dropdown
            selectedItem={currentInvoiceStatus}
            options={invoiceStatuses}
            itemToString={item => item && item.name}
            onChange={this.filterByInvoiceStatus}
          />
        </FilterGroup>
        {sentToClientOptions && (
          <FilterGroup label='Sent to client'>
            <Dropdown
              selectedItem={sentStatus}
              options={sentToClientOptions}
              itemToString={item => item && item.name}
              onChange={setSentToClientFilter}
            />
          </FilterGroup>
        )}
        <FilterGroup label='Select date range'>
          <DatePickerRange
            dateOnly
            fromDate={query.startDate}
            toDate={query.endDate}
            onFromChange={this.filterByStartDate}
            onToChange={this.filterByEndDate}
          />
        </FilterGroup>
        {sentToClientOptions && (
          <FilterGroup>
            <Checkbox
              label='Unpaid invoices only'
              value={query.unpaidOnly}
              onChange={this.filterUnpaidInvoices}
            />
          </FilterGroup>
        )}
      </SearchPanelContainer>
    )
  }
}

export default observer(InvoicesFilterPanel)
